import htmlTemplateIndex from './index.html'
import { showAccountDetails } from './account-details/show.js'

// import * as mInviteCreate from './invites/invite-create.js'
// import * as mInviteList from './invites/invite-list.js'

import { setElementHtml } from '../../../helpers/generic-js/dom.js'
import { checkPageRestriction } from '../../../helpers/restrictions/check-page-restriction.js'
import { applyHtmlRestrictions } from '../../../helpers/restrictions/apply-html-restrictions.js'
import { showUserList } from './users/user-list.js'
import { showInvites } from './invites/show-invites.js'

/**
 *
 * @returns
 */
export async function showPageAppAccount (params) {
  const { browserAppAccount, browserAppUser, containerElementId } = params
  console.log('account showPageAppAccount')
  console.log(browserAppAccount.data)

  if (!checkPageRestriction({ browserAppUser, browserAppAccount, allowPublic: true })) return

  // Prepare the html
  let htmlIndex = htmlTemplateIndex
  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppAccount, browserAppUser })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  document.title = ['Account Info:', browserAppAccount.data?.appAccount?.name].join(' ')

  showAccountDetails({
    browserAppAccount,
    browserAppUser
  })

  showUserList({
    browserAppAccount,
    browserAppUser
  })

  showInvites({
    browserAppAccount,
    browserAppUser,
    create: {
      containerElementId: 'createInvite',
      callback: function () {
        showUserList({
          browserAppAccount,
          browserAppUser
        })
      }
    },
    list: {
      containerElementId: 'invitesList'
    }
  })
}
